import { Box, Button, CircularProgress, Typography, makeStyles } from '@material-ui/core';
import { PaymentMethodType } from 'features/payment/containers/AddInformationContainer';
import { themeStep } from 'features/step-menu/themeStep';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  addButton: {
    backgroundColor: themeStep.palette.grey[800],
    color: themeStep.palette.primary.contrastText,
    padding: '0 12px',
    height: 40,
    width: '100%',
    borderRadius: 8,
    marginTop: 20,
    marginBottom: 20,
    '&:hover': {
      backgroundColor: themeStep.palette.grey[800],
    },
  },
  addButtonText: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '2.4rem',
    textTransform: 'none',
    color: themeStep.palette.grey[100],
  },
});

interface SubmitButtonProps {
  onSubmit: () => void;
  loading: boolean;
  checkRenderPaymentMethod: () => boolean;
  selected: string;
}

function SubmitButtonStep({
  onSubmit,
  loading,
  checkRenderPaymentMethod,
  selected,
}: SubmitButtonProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [checkLoading, setCheckLoading] = useState(loading);
  useEffect(() => {
    if (!loading) {
      setCheckLoading(loading);
    }
  }, [loading]);

  const onClickButton = async () => {
    await setCheckLoading(true);
    await onSubmit();
  };

  return (
    <Box display="flex" style={{ flex: 1 }}>
      <Button
        disabled={checkLoading}
        onClick={onClickButton}
        className={classes.addButton}
        variant="contained"
        color="inherit"
      >
        {checkLoading && <CircularProgress color="secondary" size={20} />}
        {!checkLoading && (
          <Typography className={classes.addButtonText}>
            {t(
              !checkRenderPaymentMethod() || selected === PaymentMethodType.CASH
                ? 'place_order_and_pay_at_counter'
                : 'Place order',
            )}
          </Typography>
        )}
      </Button>
    </Box>
  );
}

export default SubmitButtonStep;
